module.exports = __webpack_public_path__ + "img/antes_despues_175.06803e60.png";